// eslint-disable-next-line
import {BasicLayout,mBasicLayout } from '@/layouts'
/**
 * 路由
 * @type { *[] }
 */
export const pcMenu=[
  {
    path: '/',
    component: BasicLayout,
    redirect: '/Index',
    children: [
      {
        path: '/Index',
        name: 'Index',
        meta: { title: '首页' },
        component: () => import('@/views/Index/index')
      }
    ]
  },
  {
    path: '/Product',
    component: BasicLayout,
    redirect: '/Product',
    children: [
      {
        path: '/Product',
        name: 'Product',
        meta: { title: '产品中心' },
        component: () => import('@/views/Product/product')
      },
      {
        path: '/ProductPage/:id',
        name: 'ProductPage/:id',
        meta: { title: '产品中心' },
        component: () => import('@/views/Product/productPage')
      }
    ]
  },
  {
    path: '/Solution',
    component: BasicLayout,
    redirect: '/Solution',
    children: [
      {
        path: '/Solution',
        name: 'Solution',
        meta: { title: '解决方案' },
        component: () => import('@/views/Solution/solution')
      },
      {
        path: '/solutionPage/:id',
        name: 'solutionPage/:id',
        meta: { title: '解决方案' },
        component: () => import('@/views/Solution/solutionPage')
      }
    ]
  },
  {
    path: '/News',
    component: BasicLayout,
    redirect: '/News',
    children: [
      {
        path: '/News',
        name: 'News',
        meta: { title: '新闻动态' },
        component: () => import('@/views/News/news')
      },
      {
        path: '/NewDetails/:id',
        name: 'NewDetails/:id',
        meta: { title: '新闻动态' },
        component: () => import('@/views/News/newDetails')
      }
    ]
  },
  {
    path: '/Work',
    component: BasicLayout,
    redirect: '/Work',
    children: [
      {
        path: '/Work',
        name: 'Work',
        meta: { title: '加入我们' },
        component: () => import('@/views/Work/work')
      },
      {
        path: '/WorkDetails/:id',
        name: 'WorkDetails/:id',
        meta: { title: '招聘详情' },
        component: () => import('@/views/Work/workDetails')
      }
    ]
  },
  {
    path: '/About',
    component: BasicLayout,
    redirect: '/About',
    children: [
      {
        path: '/About',
        name: 'About',
        meta: { title: '关于我们' },
        component: () => import('@/views/About/about')
      }
    ]
  },
]
export const mMenu=[
  {
    path: '/MIndex',
    component: mBasicLayout,
    redirect: '/MIndex',
    children: [
      {
        path: '/MIndex',
        name: 'MIndex',
        meta: { title: '首页' },
        component: () => import('@/views/M/Index/index')
      },
      {
        path: '/MExperience',
        name: 'MExperience',
        meta: { title: '立即体验' },
        component: () => import('@/views/M/Index/experience')
      }
    ]
  },
  {
    path: '/MProduct',
    component: mBasicLayout,
    redirect: '/MProduct',
    children: [
      {
        path: '/MProduct',
        name: 'MProduct',
        meta: { title: '产品中心' },
        component: () => import('@/views/M/Product/product')
      },
      {
        path: '/MProductPage/:id',
        name: 'MProductPage/:id',
        meta: { title: '产品中心' },
        component: () => import('@/views/M/Product/productPage')
      }
    ]
  },
  {
    path: '/MSolution',
    component: mBasicLayout,
    redirect: '/MSolution',
    children: [
      {
        path: '/MSolution',
        name: 'MSolution',
        meta: { title: '解决方案' },
        component: () => import('@/views/M/Solution/solution')
      },
      {
        path: '/MSolutionPage/:id',
        name: 'MSolution/:id',
        meta: { title: '解决方案' },
        component: () => import('@/views/M/Solution/solutionPage')
      }
    ]
  },
  {
    path: '/MNews',
    component: mBasicLayout,
    redirect: '/MNews',
    children: [
      {
        path: '/MNews',
        name: 'MNews',
        meta: { title: '新闻动态' },
        component: () => import('@/views/M/News/news')
      },
      {
        path: '/MNewDetails/:id',
        name: 'MNewDetails/:id',
        meta: { title: '新闻动态' },
        component: () => import('@/views/M/News/newDetails')
      }
    ]
  },
  {
    path: '/MWork',
    component: mBasicLayout,
    redirect: '/MWork',
    children: [
      {
        path: '/MWork',
        name: 'MWork',
        meta: { title: '加入我们' },
        component: () => import('@/views/M/Work/work')
      },
      {
        path: '/MWorkDetails/:id',
        name: 'MWorkDetails/:id',
        meta: { title: '招聘详情' },
        component: () => import('@/views/M/Work/workDetails')
      }
    ]
  },
  {
    path: '/MAbout',
    component: mBasicLayout,
    redirect: '/MAbout',
    children: [
      {
        path: '/MAbout',
        name: 'MAbout',
        meta: { title: '关于我们' },
        component: () => import('@/views/M/About/about')
      }
    ]
  },
]
export const constantRouterMap =pcMenu.concat(mMenu)
